const PlayTitlePosition = {

    LEFT_TOP: 0,
    RIGHT_TOP: 1,
    LEFT_BOTTOM: 2,
    RIGHT_BOTTOM: 3,
}
export default PlayTitlePosition